import { render } from "./Address.vue?vue&type=template&id=0d727859&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=0d727859&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d727859"

export default script